module.exports = __webpack_public_path__ + "static/media/Island.177cb549.jpg";